import { css } from "styled-components";

export const mobile = (props) => {
  return css`
    @media only screen and (max-width: 380px) {
      ${props}
    }
  `;
};
export const laptopsm = (props) => {
  return css`
    @media only screen and (max-width: 1100px) {
      ${props}
    }
  `;
};
export const tab = (props) => {
  return css`
    @media only screen and (max-width: 950px) {
      ${props}
    }
  `;
};
export const tabsm = (props) => {
  return css`
    @media only screen and (max-width: 850px) {
      ${props}
    }
  `;
};

export const mobileUsual = (props) => {
  return css`
    @media only screen and (max-width: 700px) {
      ${props}
    }
  `;
}


export const desktop = (props) => {
  return css`
    @media only screen and (min-width: 1100px) {
      ${props}
    }
  `;
};